export default __webpack_public_path__ + "static/media/app-gestione-ospiti.27115623.png";